module.exports = __webpack_public_path__ + "img/logo-yarrah.2ce45347.svg";